import React, { useEffect } from 'react'
import once from 'lodash/once'
import { ROUTES } from '@constants/index'
import { drawerEventEmitter } from '@utils/drawerEventEmitter'
import { useCreateClaimRecord } from '@hooks/useCreateClaimRecord'
import { LoadingSkeleton } from './LoadingSkeleton'

export const StartRedirect: React.FC = () => {
  const { createClaimRecord, isCreating } = useCreateClaimRecord()

  useEffect(() => {
    startClaimApplication()
  }, [])

  const startClaimApplication = once(() => {
    createClaimRecord().then(claimRecord => {
      drawerEventEmitter.openDrawer({ target: ROUTES.RESUME, navigateState: { claimRecordId: claimRecord?.id } })
    })
  })

  if (isCreating) {
    return <LoadingSkeleton />
  }

  return null
}
